/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUserProfile = /* GraphQL */ `
  query GetUserProfile($id: ID!) {
    getUserProfile(id: $id) {
      id
      name
      pillars {
        title
        glowPercent
      }
      projects {
        title
        backgroundColor
        shortName
      }
      morningRoutineSteps
      eveningRoutineSteps
      tasks {
        description
        goalTag
        urgency
        category
        glowTask
        timeConstraintType
        timeConstraintTime
        associatedMilestone
        status
      }
      dates {
        date
        meals
        pxp
        gxp
      }
      goals {
        goalType
        title
        milestones
        timeConstraintType
        timeConstraintTime
        projectId
        isGlowGoal
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listUserProfiles = /* GraphQL */ `
  query ListUserProfiles(
    $filter: ModelUserProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        pillars {
          title
          glowPercent
        }
        projects {
          title
          backgroundColor
          shortName
        }
        morningRoutineSteps
        eveningRoutineSteps
        createdAt
        updatedAt
        owner
        tasks {
          description
          goalTag
          urgency
          category
          glowTask
          timeConstraintType
          timeConstraintTime
          associatedMilestone
          status
        }
        dates {
          date
          meals
          pxp
          gxp
        }
        goals {
          goalType
          title
          milestones
          timeConstraintType
          timeConstraintTime
          projectId
          isGlowGoal
        }
      }
      nextToken
    }
  }
`;
